export const APP_ORG = import.meta.env.VITE_APP_ORG || 'AI-Bees';
export const APP_NAME = import.meta.env.VITE_APP_NAME || 'AI-Bees';
export const APP_STAGE = import.meta.env.VITE_APP_STAGE || 'dev';
export const IS_DEV_SERVER =
  APP_STAGE === 'dev' ||
  import.meta.env.DEV ||
  window.location.origin.includes('dev.');
export const LOG_API_CALL_DURATION_ENABLE =
  import.meta.env.VITE_LOG_API_CALL_DURATION_ENABLE === 'true';

/** Performance mark name for measuring delay from filter change → API call */
export const FILTER_CHANGE_PERF_MARK = 'filter-change';

/** Performance measure name for filter change → API call delay */
export const FILTER_CHANGE_TO_API_CALL_MEASURE = 'filter-change-to-api-call';
